import { $, on } from "@olmokit/dom";
import { hasGtm } from "@olmokit/core/analytics";
import AuthFormRegister from "@olmokit/core/auth/form-register";
import FormsInputMaterial from "@olmokit/core/forms/input/material";
import FormsSelectMaterial from "@olmokit/core/forms/select/material";
import Dependency from "@olmokit/core/olmoforms/dependency";
import "@olmokit/core/forms/checkbox";
import "./index.scss";

/**
 * Component: Form register
 */
export function FormRegister() {
  console.log('FormRegister mounted');

  const $error = $(".FormRegister: .error");

  if (sessionStorage.hasOwnProperty("signup")) {
    $('#of-register-profession').value = sessionStorage.getItem("signup");
  }

  FormsInputMaterial();
  FormsSelectMaterial();
  Dependency(".FormRegister:");

  const $input = $('.of:el.of:state input')

  const $usastate = $('#of-register-usastate');

  on($usastate, 'change', () => {
    $input.value = $usastate.value;
  });

  const $canadastate = $('#of-register-canadastate');

  on($canadastate, 'change', () => {
    $input.value = $canadastate.value;
  });

  AuthFormRegister($(".FormRegister"), {
    succeded: (formData, instance, response) => {
      $error.innerHTML = response.data.msg || "";
      // location.href = response.data.redirect;

      console.log(response);

      const {
        password,
        passwordcheck,
        _redirect,
        _timezone_offset,
        _token,
        ...userTrackData
      } = formData;

      if (hasGtm()) {
        dataLayer.push({
          ...userTrackData,
          userId: response.data?.user?.id,
          event: "form sent",
          form: "Sign Up",
          eventCallback: function () {
            location.href = response.data.redirect;
          },
          eventTimeout: 2000,
        });
      } else {
        // location.href = response.data.redirect;
      }
    },
    failed: (formData, instance, response) => {
      $error.innerHTML = response.data.msg;
      setTimeout(() => {
        $error.innerHTML = "";
      }, 3000);
    },
  });

}
